import { el } from "./dom.js";
import { MAG } from "./magazine/kit.js";
import { navigate } from "../main.js";
import { cachedNews } from "../api/news.js";
import { storiesAbout, applyNewsPrefs, loadNewsPrefs } from "../utils/news-prefs.js";
import { timeAgo } from "../utils/news.js";

// "In the news" on a library item's detail page (design_documents/news.md §9):
// the latest stories from the last Newsstand issue that mention it. No network
// call — it reads the issue the Newsstand saved; hidden when nothing matches.

export function inTheNews(item) {
	const news = cachedNews();
	const stories = storiesAbout(item, applyNewsPrefs(news?.items ?? [], loadNewsPrefs()));
	if (!stories.length) return "";
	return el(
		"div",
		{ style: { padding: "12px 16px 0" } },
		el("div", {
			style: {
				display: "flex", justifyContent: "space-between", alignItems: "baseline",
				fontFamily: "'Archivo', sans-serif", fontWeight: "900", fontSize: "8.5px",
				letterSpacing: ".14em", textTransform: "uppercase", color: MAG.dim, marginBottom: "6px",
			},
		},
		"In the news",
		el("button", {
			type: "button",
			onclick: () => navigate("/news"),
			style: { background: "none", border: "0", padding: "0", cursor: "pointer", font: "inherit", color: "#ffe600" },
		}, "Newsstand ›")),
		...stories.map((s) =>
			el("a", {
				href: s.link,
				target: "_blank",
				rel: "noopener noreferrer",
				style: {
					display: "block", textDecoration: "none", color: MAG.ink, padding: "8px 10px", marginTop: "6px",
					borderRadius: "10px", background: "rgba(255,255,255,.06)", border: `1px solid ${MAG.line}`,
				},
			},
			el("div", { style: { fontFamily: "'Archivo', sans-serif", fontWeight: "800", fontSize: "12.5px", lineHeight: "1.3" } }, s.title),
			el("div", { style: { fontFamily: "'Archivo', sans-serif", fontSize: "10.5px", color: MAG.dim, marginTop: "2px" } },
				`${s.source} · ${timeAgo(s.published)} ↗`)),
		),
	);
}
